import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const GenderMaleShape = ({
  width = 19,
  height = 19,
  fillColor = 'none'
}: BaseSVGType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 19"
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 11.1979C12.5 9.70644 11.904 8.35568 10.9352 7.36829L10.8888 7.32153C9.89913 6.33658 8.53685 5.72916 7.03125 5.72916C4.01095 5.72916 1.56251 8.17761 1.5625 11.1979C1.5625 14.2182 4.01094 16.6667 7.03125 16.6667C10.0515 16.6667 12.5 14.2182 12.5 11.1979ZM18.2292 4.94791C18.2292 5.37938 17.8794 5.72916 17.4479 5.72916C17.0164 5.72915 16.6667 5.37938 16.6667 4.94791V2.66257L12.5161 6.79825C13.4831 8.00244 14.0625 9.53302 14.0625 11.1979C14.0625 15.0812 10.9145 18.2292 7.03125 18.2292C3.148 18.2292 0 15.0811 0 11.1979C5.15547e-06 7.31467 3.148 4.16666 7.03125 4.16666C8.68603 4.16666 10.2083 4.73908 11.4091 5.69556L15.557 1.5625H13.2812C12.8498 1.5625 12.5 1.21272 12.5 0.78125C12.5 0.349778 12.8498 0 13.2812 0H17.4479C17.8794 0 18.2292 0.349778 18.2292 0.78125V4.94791Z"
        fill="black"
      />
    </svg>
  );
};

export default GenderMaleShape;
